module.exports = __webpack_public_path__ + "static/img/2018-B.af91b09.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2018-B.png
// module id = FZMT
// module chunks = 1